// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { Config } from "../config";
import {
    CreateEnterpriseUserRequest,
    LanguageOption,
    SetPreferredLanguageRequest,
} from "./types/enterpriseUserApiTypes";
import { EnterpriseUser, SearchEnterpriseUsersRequest } from "./types/search.service.types";

const apiManagementRootUrl: string | undefined = Config.REACT_APP_CCL_API_MANAGEMENT_URL;

// Define a service using a base URL and expected endpoints
export const cclTokenedEnterpriseUserApi = createApi({
    reducerPath: "cclTokenedEnterpriseUserApi",
    tagTypes: ["Users", "PreferredLanguage"],
    baseQuery: fetchBaseQuery({
        baseUrl: apiManagementRootUrl,
        prepareHeaders: (headers, { getState }) => {
            //we should probably change this.
            const token = localStorage.getItem("token") as string;
            headers.set("authorization", `Bearer ${token}`);
            return headers;
        },
    }),
    endpoints: (builder) => ({
        searchEnterpriseUsers: builder.mutation<EnterpriseUser[], SearchEnterpriseUsersRequest>({
            query: (args) => ({
                url: "ccl-access2/Users/search",
                method: "POST",
                body: args,
            }),
        }),
        createNewEnterpriseUser: builder.mutation<EnterpriseUser, CreateEnterpriseUserRequest>({
            query: (args) => ({
                url: "ccl-access2/Users/enterprise",
                method: "POST",
                body: args,
            }),
        }),
        getLanguages: builder.query<LanguageOption[], void>({
            query: () => "ccl-access2/Users/languages",
        }),
        getPreferredLanguage: builder.query<LanguageOption | null, number>({
            query: (imkey) => `ccl-access2/Users/${imkey}/preferred-language`,
            providesTags: (_, __, imkey) => [{ type: "PreferredLanguage", id: imkey }],
        }),
        setPreferredLanguage: builder.mutation<void, SetPreferredLanguageRequest>({
            query: ({ imkey, languageKey }) => ({
                url: `ccl-access2/Users/${imkey}/preferred-language`,
                method: "PUT",
                body: { languageKey },
            }),
            invalidatesTags: (_, __, { imkey }) => [{ type: "PreferredLanguage", id: imkey }],
        }),
    }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
    useSearchEnterpriseUsersMutation,
    useCreateNewEnterpriseUserMutation,
    useGetLanguagesQuery,
    useGetPreferredLanguageQuery,
    useSetPreferredLanguageMutation,
} = cclTokenedEnterpriseUserApi;
